// extracted by mini-css-extract-plugin
export default {"paramContainer":"ShortcutTitle_paramContainer__IHCW7","selectedContainer":"ShortcutTitle_selectedContainer__T2nbg","matched":"ShortcutTitle_matched__fEcw8"};